<div *ngIf="this.fullTeamThreatAssessment" class="h-full w-full flex flex-col items-center gap-4 pb-4 pr-2 overflow-y-auto">
    <div class="h-full w-full flex flex-col items-center gap-4 overflow-y-auto"> 
        <div *ngFor="let section of sections; let i = index;" class="w-full flex flex-col items-start text-start gap-1">
            <h2 class="w-full text-lg oswald-font">{{ i + 1 }} - {{ section.sectionName }}</h2>
            <p *ngFor="let child of section.children; let i = index;" class="w-full text-gray-400">
                {{ child.questionText }} 
                <span *ngIf="child.type==='number' && child.answer !== 'team_determination_selection' && child.answer !== 'team_determination'" class="text-gray-text">{{ showYesNo(this.fullTeamThreatAssessment[child.answer]) }}</span>
                <span *ngIf="child.type==='string'" class="text-gray-text">{{ this.fullTeamThreatAssessment[child.answer] }}</span>
                <span *ngIf="child.type==='date'" class="text-gray-text">{{ this.fullTeamThreatAssessment[child.answer] | date: 'MM/dd/yyyy' }}</span>
                <span *ngIf="child.type==='datetime'" class="text-gray-text">{{ this.fullTeamThreatAssessment[child.answer] | date: 'MM/dd/yyyy - HH:mm' }}</span>

                <span 
                    *ngIf="child.type==='number' && child.answer === 'team_determination' && this.fullTeamThreatAssessment[child.answer] === 1" 
                    class="text-gray-text"
                >
                    The team is prepared to make a determination.
                </span>
                <span 
                    *ngIf="child.type==='number' && child.answer === 'team_determination' && this.fullTeamThreatAssessment[child.answer] === 0" 
                    class="text-gray-text"
                >
                    The team needs additional information in order to make a determination.
                </span>
                <span 
                    *ngIf="child.type==='number' && child.answer === 'team_determination_selection' && this.fullTeamThreatAssessment[child.answer] === 1" 
                    class="text-gray-text"
                >
                    A. Person/situation appears to pose a clear and immediate threat of serious violence toward others that requires containment and action to protect identified target(s).
                </span>
                <span 
                    *ngIf="child.type==='number' && child.answer === 'team_determination_selection' && this.fullTeamThreatAssessment[child.answer] === 2" 
                    class="text-gray-text"
                >
                    B. Person/situation appears to pose a threat of violence, exhibiting behaviors that indicate both a continuing intent to harm and efforts to acquire the capacity to carry out the plan.
                </span>
                <span 
                    *ngIf="child.type==='number' && child.answer === 'team_determination_selection' && this.fullTeamThreatAssessment[child.answer] === 3" 
                    class="text-gray-text"
                >
                    C. Person/situation does not appear to pose a threat of violence at this time, but exhibits behaviors that indicate a continuing intent to harm and potential for future violence.
                </span>
                <span 
                    *ngIf="child.type==='number' && child.answer === 'team_determination_selection' && this.fullTeamThreatAssessment[child.answer] === 4" 
                    class="text-gray-text"
                >
                    D. Person/situation does not appear to pose a threat of violence and the team believes the matter can be resolved with the development of a Response, Management, and Support Plan.
                </span>
            </p>
        </div>
    </div>
</div>


<div *ngIf="loading">
    <spinner></spinner>
</div>